function getItemIndexFromArray(array, itemId, arrayKey='device_id') {
  if (array) {
    for(let i=0;i<array.length;i++) {
      if (array[i][arrayKey] === itemId) {return i;}
    }
    return false;
  }
}



export {getItemIndexFromArray};



// WEBPACK FOOTER //
// ./src/helpers.js